import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-title-bold" }
const _hoisted_3 = { class: "card-details-rows-wrapper card-details-rows-wrapper--buyer" }
const _hoisted_4 = { class: "card-hold-details-row" }
const _hoisted_5 = { class: "hold-row-value" }
const _hoisted_6 = { class: "card-hold-details-row" }
const _hoisted_7 = { class: "hold-row-value" }
const _hoisted_8 = { class: "card-hold-details-row" }
const _hoisted_9 = { class: "hold-row-value" }
const _hoisted_10 = { class: "card-hold-details-row" }
const _hoisted_11 = { class: "hold-row-value" }
const _hoisted_12 = {
  key: 0,
  class: "card-hold-details-row"
}
const _hoisted_13 = { class: "hold-row-value" }
const _hoisted_14 = {
  key: 1,
  class: "card-hold-details-row"
}
const _hoisted_15 = { class: "hold-row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString($setup.props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hold-row-title" }, "First Name", -1)),
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.props.data.firstName), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hold-row-title" }, "Last Name", -1)),
        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.props.data.lastName), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hold-row-title" }, "Email", -1)),
        _createElementVNode("div", _hoisted_9, _toDisplayString($setup.props.data.email), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hold-row-title" }, "Phone", -1)),
        _createElementVNode("div", _hoisted_11, _toDisplayString($setup.props.data.phone), 1)
      ]),
      ($setup.props.data.companyDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hold-row-title" }, "Company", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.props.data.companyDetails), 1)
          ]))
        : _createCommentVNode("", true),
      ($setup.props.data.holderType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hold-row-title" }, "Type", -1)),
            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.props.data.holderType), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}